import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { UserType } from "./useCurrentUserQuery";

export type RibbonsType = {
  ribbonId: string
  message: string
  backgroundColor: string
  createdByUserId: string
  updatedByUserId: string | null
  createdAt: string
  updatedAt: string
  validUntil: string
  createdByUser: UserType
  updatedByUser: UserType | null
  startDate:string,
  couponCode:string,
  discountPercentage:number,
  couponDuration:number,
  active:boolean,
}

type RibbonResponse = ResponseType<RibbonsType[]>;


function useRibbonsListQuery() {
  return useQuery<
    AxiosResponseAndError<RibbonResponse>["response"],
    AxiosResponseAndError<RibbonResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.ribbon],
    queryFn: async () => await ApiRequest.get(`${requestURLs.ribbon}`),
    enabled: true,
    refetchInterval:15000,
  });
}

export default useRibbonsListQuery;
